export function checkIsDisabledSubmitForm(form) {
  if (!form.rulesetId) return true;
  if (!form.yearMonth) return true;
  if (!form.brand) return true;
  if (!form.totalDaysOffPerHost) return true;
  if (!form.customDoubleDates || form.customDoubleDates.some((day) => !day)) return true;

  if (form.isEventDay) {
    const isPeakDayInvalid = form.peakDays.some((day) => {
      return !day || day.length !== 2 || !day[0] || !day[1];
    });
    if (!form.peakDays.length || isPeakDayInvalid) return true;
  }

  if (form.isAnyHostLeave) {
    if (form.hostLeaves.length) {
      if (
        form.hostLeaves.find((leave) => {
          return !leave.hostId || !leave.leaves.length;
        })
      ) {
        return true;
      }
    }
  }

  return false;
}

export default checkIsDisabledSubmitForm;
